import { computed, reactive, readonly, toRefs } from 'vue'
import { shopProducts } from '../../../../Greativ/shop/product'
import _forEach from 'lodash/forEach'
import _find from 'lodash/find'
import _map from 'lodash/map'
import { vatPrice, roundPrice } from '../../../../Greativ/helper/price'
import { shopBasketAddItems } from '../../../../Greativ/shop/basket'

const state = reactive({
  products: [],
  selectedProducts: {},
})

export const loadProducts = async () => {
  const ticketsCategoryId = window.ticket.tickets_category_id
  if (ticketsCategoryId) {
    const { success, products } = await shopProducts({
      category_id: window.ticket.tickets_category_id,
      page_limit: 100,
    })

    if (success) {
      state.products = products
    }
  }
}

export const products = readonly(toRefs(state).products)

export const setSelectedProduct = (id, amount) => {
  state.selectedProducts[id] = amount
}

export const productsTotalPriceWithVat = computed(() => {
  let price = 0

  _forEach(state.selectedProducts, (amount, id) => {
    const product = _find(state.products, {
      id: parseInt(id),
    })

    if (product) {
      price +=
        roundPrice(
          vatPrice(
            product.client_price || product.discount_price || product.price,
            product.vat
          )
        ) * amount
    }
  })

  return readonly(price)
})

export const selectedProductsAmount = computed(() => {
  let collectAmount = 0

  _forEach(state.selectedProducts, (amount) => {
    collectAmount += amount
  })

  return readonly(collectAmount)
})

export const addToCart = async () => {
  const response = await shopBasketAddItems(
    _map(state.selectedProducts, (amount, id) => {
      return {
        productId: id,
        amount,
        data: {},
        set_data: {},
      }
    })
  )

  if (response.success) {
    const dataProducts = []
    let totalPriceWithVat = 0

    response.items.forEach((product, productIndex) => {
      const priceWithVat = roundPrice(vatPrice(product.price, product.vat))
      let discountPriceWithVat = null
      if (product.discountPrice) {
        discountPriceWithVat = priceWithVat - roundPrice(vatPrice(product.discountPrice, product.vat))
      }
      if (discountPriceWithVat !== null) {
        totalPriceWithVat += discountPriceWithVat * product.amount
      } else {
        totalPriceWithVat += priceWithVat * product.amount
      }

      let categoryName = ''

      if (product.categories.length > 0) {
        categoryName = product.categories[0].name
      }

      dataProducts.push({
        index: productIndex,
        item_id: product.productCode || product.id,
        item_name: product.productName,
        item_brand: '',
        item_category: categoryName,
        price: priceWithVat,
        discount: discountPriceWithVat || 0,
        quantity: product.amount,
      })
    })

    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = []
    }
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value: totalPriceWithVat,
        items: dataProducts
      },
    })
  }

  return {
    success: response.success,
    message: response.message,
  }
}
